/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Meal_BreakfastInputs */

const en_for_whom_meal_breakfast = /** @type {(inputs: For_Whom_Meal_BreakfastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breakfast`)
};

const pl_for_whom_meal_breakfast = /** @type {(inputs: For_Whom_Meal_BreakfastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śniadanie`)
};

/**
* | output |
* | --- |
* | "Breakfast" |
*
* @param {For_Whom_Meal_BreakfastInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_meal_breakfast = /** @type {((inputs?: For_Whom_Meal_BreakfastInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Meal_BreakfastInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_meal_breakfast(inputs)
	return en_for_whom_meal_breakfast(inputs)
});